// extracted by mini-css-extract-plugin
export default {"wrapper":"UserPassword_wrapper__GBc0K","buttons":"UserPassword_buttons__XZ22f","buttonOptions":"UserPassword_buttonOptions__V3haz","passwordMask":"UserPassword_passwordMask__qXDs6"};